import {collection, doc, getDoc, getDocs, query, updateDoc, where} from "firebase/firestore";
import {auth, db} from "../configs/firebase-config";
import {sendEmailVerification} from "firebase/auth";
import {toast, ToastOptions} from "react-toastify";

export const  promptUserForName = async () => {
  const firstName = await window.prompt("First Name: ");
  const lastName = await window.prompt("Last Name: ");
  return {firstName, lastName};
}

export const checkSubscription = async (uid: string) => {
  const userDocRef = doc(db, "users", `${uid}`);
  const subsCollectionRef = collection(userDocRef, "subscriptions");
  const q = query(subsCollectionRef, where("status", "in", ["trialing", "active"]))
  const result = await getDocs(q);
  return !result.empty;
};

export const checkUserDoc = async (user: any) => {
  const uid = user.uid;
  const userDocRef = doc(db, "users", `${uid}`);
  const match = await getDoc(userDocRef);

  if(match.exists() && match.get("displayName")) return;

  const name = await promptUserForName();
  await updateDoc(userDocRef, {
    firstName: name.firstName,
    lastName: name.lastName,
    userId: uid,
    email: user.email,
    displayName: user.displayName ? user.displayName : `${name.firstName} ${name.lastName}`,
    photoURL: user.photoURL
  });

}

export const authChecks = async (userCredentials: any) => {
  if (userCredentials.user.emailVerified) {
    await checkUserDoc(userCredentials.user);
    return await checkSubscription(userCredentials.user.uid);
  } else {
    await checkUserDoc(userCredentials.user);
    await sendEmailVerification(userCredentials.user).then(() => {
      window.location.replace("/verification");
    }).catch((error) => {
      displayToast(error.code, toastType.error);
    })
  }
}

export const  getTimeStamp = () => {
  let now = new Date();
  return (
    (now.getDate()) + "-" +
    (now.getMonth() + 1) + "-" +
    now.getFullYear() + " " +
    now.getHours() + ":" +
    ((now.getMinutes() < 10)
      ? ("0" + now.getMinutes())
      : (now.getMinutes())) + ":" +
    ((now.getSeconds() < 10)
      ? ("0" + now.getSeconds())
      : (now.getSeconds())
    )
  );
}

export const displayToast = (message: string, type:string) => {
  // https://fkhadra.github.io/react-toastify/introduction
  const defaultToastOptions: ToastOptions = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

  if(type === "success") {
    toast.success(message, {
      className: toastStyle.success,
      ...defaultToastOptions
    });
  } else if (type === "error") {
    toast.error(message,{
      className: toastStyle.error,
      ...defaultToastOptions
    });
  }else if (type === "warn") {
    toast.warn(message,{
      className: toastStyle.warn,
      ...defaultToastOptions
    });
  }else if (type === "info") {
    toast.info(message, {
      className: toastStyle.info,
      ...defaultToastOptions
    });
  }else {
    toast.error("Something went wrong!",{
      className: toastStyle.default,
      ...defaultToastOptions
    });
  }
}

export const testNotify = () => {
  displayToast("Success", toastType.success);
  displayToast("Error", toastType.error);
  displayToast("Warning", toastType.warn);
  displayToast("Info", toastType.info);
  displayToast("🦄 Wow so easy! Innit Bro", toastType.success);
}

export const toastType: any = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
  dark: "dark"
};

export const toastStyle: any = {
  // Tailwind styling goes here
  // success: "bg-green-600",
  // error: "bg-red-600",
  // info: "bg-gray-600",
  // warn: "bg-orange-400",
  // default: "bg-indigo-600",
  // dark: "bg-white-600 font-gray-300",
};

export const checkPostLiked = async (docID: string) => {
  if (!(auth.currentUser?.uid)) return false;
  const snapshot = await getDoc(doc(db, "post-hearts", `${auth.currentUser.uid}_${docID}`));
  return snapshot.exists();
}

export const checkBookmark = async (docID: string) => {
  if (!(auth.currentUser?.uid)) return false;
  const snapshot = await getDoc(doc(db, "bookmarks", `${auth.currentUser.uid}/posts/${docID}`));
  return snapshot.exists();
}